import React from "react"
import {
  STATISTIC_TYPE,
  TABLE_OPERATION_TYPE,
} from "types/ReportingDashboard/elements.types"
import {
  XTAB_STATISTIC_OPTIONS,
  DTAB_STATISTIC_OPTIONS,
} from "features/Reporting/components/ReportingDisplay/Elements/shared/StatisticTypeSelectOptions"

interface BuilderStatsRowProps {
  operation: TABLE_OPERATION_TYPE
  selectedOperators: STATISTIC_TYPE[]
  onToggle: (op: STATISTIC_TYPE) => void
}

/**
 * Statistic pill toggles. Options swap based on XTAB / DTAB context.
 * Reads its option list from the shared Reporting StatisticTypeSelectOptions
 * so the Builder and the Reporting dashboard stay in lockstep.
 */
const BuilderStatsRow: React.FC<BuilderStatsRowProps> = ({
  operation,
  selectedOperators,
  onToggle,
}) => {
  const options =
    operation === TABLE_OPERATION_TYPE.XTAB
      ? XTAB_STATISTIC_OPTIONS
      : DTAB_STATISTIC_OPTIONS

  return (
    <div className="qc-stats-row" role="group" aria-label="Statistics">
      {options.map((opt) => {
        const isSelected = selectedOperators.includes(opt.value)
        return (
          <button
            key={opt.value}
            type="button"
            className="qc-stat-pill"
            data-selected={isSelected}
            aria-pressed={isSelected}
            onClick={() => onToggle(opt.value)}
          >
            {opt.label}
          </button>
        )
      })}
    </div>
  )
}

export default BuilderStatsRow
